import {ActionTypes} from '../constants/ActionTypes';

const initialState = [];

const notifications = (state = initialState, action) => {
    switch (action.type) {
        case ActionTypes.SET_NOTIS:
            return setNotis(state, action);
    }

    return state;
};

function setNotis(state, action) {
    const {notifications} = action;

    return notifications;
}

const notiCount = (state = 0, action) => {
    switch (action.type) {
        case ActionTypes.SET_NOTI_COUNT:
            return setNotiCount(state, action);
    }

    return state;
};

function setNotiCount(state, action) {
    const {notiCount} = action;

    return notiCount;
}

export {notifications, notiCount};


// WEBPACK FOOTER //
// ./src/reducers/notifications.js